<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5C46.2924 0.5 59.5 13.7076 59.5 30Z"
      fill="white"
      stroke="#E9E9E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 27.8002V36.5386C18 37.898 19.1939 39.0001 20.6667 39.0001H39.3333C40.8061 39.0001 42 37.898 42 36.5386V25.4616C42 25.4545 42 25.4473 41.9999 25.4402V27.8001L32.4 33.0268C30.9778 33.8801 29.0223 33.8801 27.6 33.0268L18 27.8002Z"
      fill="#222222"
    />
    <path
      d="M42 25.1333L32.4001 30.36C30.9779 31.2133 29.0224 31.2133 27.6001 30.36L18 25.1333C18 24.0667 19.3333 23 20.6667 23H39.3333C40.9231 23 42 24.0667 42 25.1333Z"
      fill="#222222"
    />
  </svg>
</template>
